import { fontsMetaData } from '@wix/thunderbolt-fonts';
import coreUtilsLib from '@wix/santa-core-utils';

export const fontUtils = coreUtilsLib.createFontUtils(fontsMetaData);
